export default {
    provide() {
        return {
            resolveAttachmentIcon: this.resolveAttachmentIcon,
            downloadAttachment: this.downloadAttachment,
            deleteAttachment: this.deleteAttachment,
        };
    },
    methods: {
        async downloadAttachment(file) {
            const { uuid, file_name, original_file_name } = file;

            if (!uuid) {
                throw new Error(this.$t('blood_donors.attachment_undefined_id'));
            }

            if (!this.$can('Attachments - Download')) {
                throw new Error(this.$t('permissions.no_permission_for_this_action', { details: 'attachments_download' }));
            }


            const response = await window.axios.get(`/attachments/${uuid}/download`,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/json',
                        'Content-Disposition': `attachment; filename="${file_name}"`
                    }
                });

            this.downloadFile(response.data, original_file_name);
        },
        async deleteAttachment(id) {
            if (!id) {
                throw new Error(this.$t('blood_donors.attachment_undefined_id'));
            }

            if (!this.$can('Attachments - Remove')) {
                throw new Error(this.$t('permissions.no_permission_for_this_action', { details: 'attachments_remove' }));
            }

            return await window.axios.delete(`/attachments/${id}`);
        },
        resolveAttachmentIcon(extension) {
            switch (extension) {
                case 'png':
                case 'jpg':
                case 'jpeg':
                case 'gif':
                    return 'uil-image';
                case 'txt':
                    return 'uil-file-info-alt';
                default:
                    return 'uil-file';
            }
        },
        downloadFile(data, filename) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
        },
        isFileImage(extension) {
            const file = this.resolveAttachmentIcon(extension);

            return file === 'uil-image';
        }
    }
}